import axios from 'axios';

export const urlBase = process.env.REACT_APP_BACKEND_HOST ?? `api.${window.location.host}`;

export const webClient = axios.create({
    baseURL: `https://${urlBase}`,
    timeout: 10000,
    withCredentials: true
});